import { useAuthenticationContext } from '@festina-life/authentication'
import { dateUtils } from '@festina-life/core'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { useEntityParams } from '../../hooks/useEntityParams'
import { useHook } from '../../lenteHooks'

export const CommitmentTime = () => {
  const translate = useTranslate()
  const { ownerId, tenantId } = useEntityParams()
  const { isInTestMode } = useAuthenticationContext()

  const { data } = useHook('fetchers.life.useFetchCommitmentSources')(
    { ownerId, tenantId },
    {
      enabled: isInTestMode,
    },
  )
  const commitmentTime = data?.commitmentTime

  return (
    <>
      {isInTestMode && commitmentTime && (
        <Alert
          severity="warning"
          title={translate('commitmentSource.commitmentTime', {
            commitmentTime: dateUtils.dateAsStr(commitmentTime),
          })}
        />
      )}
    </>
  )
}
